import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";

export class PdfFooter extends Component {
  render() {
    return (
      <Row className="pdf-footer">
        <Col>https://pmg.dpiit.gov.in</Col>
      </Row>
    );
  }
}
